import ApiError from "../../errors/ApiError";
import { LINK_CUSTOMER_GUESTY_ERROR } from "./error-codes.constants";

export class LinkCustomerGuestyError extends ApiError {
  constructor() {
    super(LINK_CUSTOMER_GUESTY_ERROR);
  }
}
